/* Colores en tarjetas de producto (metacampo custom.swatches)
   Ubica los colores dentro de la imagen de la tarjeta. Al pasar el mouse por un color
   cambia foto, nombre, precio y enlaces; al salir de la tarjeta vuelve al original. */
if (!customElements.get('wd-card-swatches')) {
  customElements.define(
    'wd-card-swatches',
    class WdCardSwatches extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;

        this.card = this.closest('li')?.querySelector('.card-wrapper');
        const inner = this.card?.querySelector('.card__inner');
        if (!inner) return;

        this.canHover = window.matchMedia('(hover: hover)').matches;
        this.dataset.ready = 'true';
        // Con mouse va sobre la imagen; en táctil, justo debajo
        if (this.canHover) inner.appendChild(this);
        else inner.after(this);

        if (!this.canHover) return;

        this.items = this.querySelectorAll('.wd-csw__item');
        this.items.forEach((item) => {
          item.addEventListener('mouseenter', () => this.apply(item));
          item.addEventListener('focus', () => this.apply(item));
        });
        this.card.addEventListener('mouseenter', () => this.preload(), { once: true });
        this.card.addEventListener('mouseleave', () => this.apply(this));
      }

      preload() {
        const sizes = this.card.querySelector('.card__media img')?.sizes || '';
        this.items.forEach((item) => {
          if (!item.dataset.src) return;
          const img = new Image();
          img.sizes = sizes;
          img.srcset = item.dataset.srcset;
          img.src = item.dataset.src;
        });
      }

      apply(source) {
        const d = source.dataset;
        const card = this.card;
        const img = card.querySelector('.card__media img');

        if (img && d.src && img.dataset.wdCurrent !== d.src) {
          img.dataset.wdCurrent = d.src;
          img.srcset = d.srcset;
          img.src = d.src;
        }
        card.classList.toggle('wd-csw-swapped', source !== this);

        card.querySelectorAll('.card__media-link, .card__heading a').forEach((a) => (a.href = d.url));
        card.querySelectorAll('.card__heading a').forEach((a) => (a.textContent = d.title));
        card.querySelectorAll('[data-quick-view-handle]').forEach((el) => (el.dataset.quickViewHandle = d.handle));

        card.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach((el) => {
          el.textContent = d.price;
        });
        card.querySelectorAll('.price__sale s.price-item--regular').forEach((el) => (el.textContent = d.compare));
        card.querySelectorAll('.price').forEach((el) => el.classList.toggle('price--on-sale', Boolean(d.compare)));

        this.items.forEach((item) => item.classList.toggle('is-active', item.dataset.url === d.url));
      }
    }
  );
}
